<motn-drawer-height-from-bottom
  [fitContent]="true"
  (clickedOutside$)="clickedOutside$.emit($event)"
>
  <h3>
    Configure Hub
    @if (hub) {
      <motn-pill squareLetter="h">{{ hub.ID }}</motn-pill>
    }
  </h3>

  @if (!hub) {
    <motn-spinner></motn-spinner>
  }

  @if (hub) {
    <div
      class="content"
    >
      <div class="flex">
        <div>
          <input
            [(ngModel)]="hub.Name"
            (ngModelChange)="updateStatus('edited')"
          >
          <div
            class="label"
          >
            Name
          </div>
        </div>

        <div>
          <select
            [(ngModel)]="hub.TimeZone"
            (ngModelChange)="updateStatus('edited')"
          >
            @for (timeZone of timeZones; track timeZone) {
              <option
                [ngValue]="timeZone"
                [innerText]="getTimeZoneString(timeZone)"
              ></option>
            }
          </select>
          <div
            class="label"
          >
            Time Zone
          </div>
        </div>
      </div>

      <div>
        <motn-save-revert-buttons
          #saveRevertButtonsComponent
          [status]="status"
          [enableRevert]="false"
          (clickedSave$)="save()"
          (updatedStatus$)="updateStatus($event)"
        ></motn-save-revert-buttons>
      </div>

      @if (showGatewayEuis) {
        <div>
          <div
            class="eui-input-field input-field-wrap"
            (click)="euiInput.focus()"
          >
            <div class="eui-input-content">
              @for (eui of gatewayEuis; track eui) {
                <motn-pill
                  [removable]="true"
                  (remove)="removeEui(eui)"
                >
                  {{ eui }}
                </motn-pill>
              }

              <input
                #euiInput
                class="eui-input"
                [(ngModel)]="gatewayEuiInput"
                (keydown.space)="$event.preventDefault(); addEui()"
                (keydown.enter)="$event.preventDefault(); addEui()"
                (blur)="addEui()"
                [placeholder]="gatewayEuis.length === 0 ? 'Enter an EUI and press space…' : ''"
              >
            </div>
          </div>
          <div
            class="label"
          >
            LoRaWAN Gateway EUIs
          </div>

          <motn-save-revert-buttons
            #lorawanSaveButtonsComponent
            [status]="lorawanStatus"
            [enableRevert]="false"
            (clickedSave$)="saveGateways()"
            (updatedStatus$)="updateLorawanStatus($event)"
          ></motn-save-revert-buttons>
        </div>
      }
    </div>
  }
</motn-drawer-height-from-bottom>
